export default __webpack_public_path__ + "static/media/icon-close-black.c835f926.svg";